/**
 * Ráfaga del lector: la distinción entre teclas que vienen de un escáner en
 * modo teclado y teclas que tipea una persona, por el intervalo entre ellas.
 *
 * Vive fuera del componente porque lo necesitan dos lugares: el campo de
 * lectura, que decide por tecla, y el modal, que recibe el Escape ANTES que el
 * campo (Radix lo escucha en captura sobre el documento) y tiene que saber si
 * ese Escape lo mandó el lector para no cerrar el diálogo. Hay un solo campo
 * de lectura montado a la vez, así que alcanza con una marca de tiempo global.
 */

/**
 * Por debajo de este intervalo entre teclas la entrada se considera del
 * lector. Los Zebra observados van de 0 a 17 ms; con "USB Keystroke Delay"
 * largo llegan a ~40 ms. Una persona no sostiene menos de 60 ms entre teclas.
 */
export const UMBRAL_RAFAGA_MS = 60;

let ultimaTeclaTs: number | null = null;

/** Lo llama el campo de lectura por cada tecla que recibe. */
export function anotarTeclaDeRafaga(ts: number): void {
  ultimaTeclaTs = ts;
}

/** ¿Hay una ráfaga del lector en curso? (última tecla hace menos del umbral) */
export function lectorEnRafaga(ahora: number = performance.now()): boolean {
  return ultimaTeclaTs != null && ahora - ultimaTeclaTs < UMBRAL_RAFAGA_MS;
}
